import { render, staticRenderFns } from "./verifiCodeLogin.vue?vue&type=template&id=6f954c9a&scoped=true"
import script from "./verifiCodeLogin.vue?vue&type=script&lang=js"
export * from "./verifiCodeLogin.vue?vue&type=script&lang=js"
import style0 from "./verifiCodeLogin.vue?vue&type=style&index=0&id=6f954c9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f954c9a",
  null
  
)

export default component.exports